var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._l(_vm.posts, function (post) {
        return _c("section-card", { key: post.id, attrs: { post: post } })
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.enabled,
              expression: "enabled",
            },
          ],
          staticClass: "title-section",
          class: _vm.sClassName,
          on: { click: _vm.getPost },
        },
        [
          _c("h3", { staticClass: "heading-title-sect text-center" }, [
            _c("span", [_vm._v("Más " + _vm._s(_vm.sName))]),
          ]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }